import memoize from 'lodash/memoize';
import { imageTypes, structureThumbnailLabel } from '@Constants/rx-ui/constants';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import * as FormatUtils from '@Services/FormatUtils';

export const getThumbnailByType = (structure, imageType, label = structureThumbnailLabel) => {
  const data = {
    imageTypes: [imageType],
    structure,
    label,
  };

  // eslint-disable-next-line no-shadow
  return MessageBroker.send(RequestUrls.molRenderRequest, data).then((data = {}) => {
    const results = data?.[imageType];

    if (!results) return results;

    results.url = FormatUtils.formatPath(results.url);

    return results;
  });
};

export const getModalThumbnail = (structure = '') => getThumbnailByType(structure, imageTypes.RESULTS_L);

export const memoGetModalThumbnail = memoize(getModalThumbnail);

export const gitStructureQueryLetThumbnail = (structure = '') => getThumbnailByType(structure, imageTypes.RESULTS_L);

export const getHistoryThumbnail = (structure = '') => {
  const data = {
    imageTypes: [imageTypes.HISTORY_THUMBNAIL],
    structure,
    label: structureThumbnailLabel,
  };
  return MessageBroker.send(RequestUrls.molRenderRequest, data);
};

export const getAlertThumbnail = (structure = '') => {
  const data = {
    imageTypes: [imageTypes.ALERT_THUMBNAIL],
    structure,
    label: structureThumbnailLabel,
  };

  return MessageBroker.send(RequestUrls.molRenderRequest, data);
};

export const memoFetAlertThumbnail = memoize(getAlertThumbnail);
